import React, { useState } from 'react'
import PropTypes from 'prop-types'
import AsyncSelect from 'react-select/async'
import School from '../../../models/School'
import District from '../../../models/District'
import Select from "react-select";

const SchoolAsyncSelect = ({ name, placeholder, jotformUrl }) => {
  const [school, setSchool] = useState()
  const [district, setDistrict] = useState()
  const [schoolEmployee, setSchoolEmployee] = React.useState("");

  const isMobile = window.screen.width < 600

  const changeHandler = (opt) => {
    setSchool(opt)
  }

  const changeDistrictHandler = (opt) => {
    setDistrict(opt)
    setSchool()
  }

  const changeSchoolEmployee = (opt) => {
    setSchoolEmployee(opt)
  }

  const options = [
    { value: "None", label: "None" },
    { value: "Principal", label: "Principal" },
    { value: "Vice-Principal", label: "Vice-Principal" },
    { value: "Office Manager", label: "Office Manager" },
    { value: "Secretary", label: "Secretary" },
    { value: "Teacher", label: "Teacher" },
    { value: "Educational Support", label: "Educational Support" }
  ];

  const formatUrl = () => {
    if (!school) return '';
    const url = new URL(jotformUrl);
    url.searchParams.append('school_employee', schoolEmployee.value);
    url.searchParams.append('schoolId', school.value);
    

    return url
  }

  const loadSchoolOptionsQuery = () => (value, callback) => {
    School
      .where({
        district_id: district.data.id,
        name: { match: value },
      })
      .order({ name: 'asc' })
      .per(50)
      .all()
      .then((res) => {
        const options = res.data.map((e) => ({ label: e.name, value: e.id, data: e }))
        callback(options)
      })
  }

  const loadDistrictOptionsQuery = () => (value, callback) => {
    District
      .where({
        name: { match: value }
      })
      .order({ name: 'asc' })
      .per(50)
      .all()
      .then((res) => {
        const options = res.data.map((e) => ({ label: e.name, value: e.id, data: e }))
        callback(options)
      })
  }

  return (
    <>
      <p style={{ fontWeight: 'bold' }}>School District</p>
      <AsyncSelect
        cacheOptions
        defaultOptions
        placeholder="Start typing to search districts..."
        defaultValue={district}
        name="district"
        loadOptions={loadDistrictOptionsQuery()}
        onChange={changeDistrictHandler}
      />

      {district && (
        <>
          <br/>
          <p style={{ fontWeight: 'bold' }}>School</p>
          <AsyncSelect
            cacheOptions
            defaultOptions
            placeholder={placeholder}
            defaultValue={school}
            name={name}
            key={district.value}
            loadOptions={loadSchoolOptionsQuery()}
            onChange={changeHandler}
          />
        </>
      )}

      {school && (
        <>
          <br/>
          <p style={{ fontWeight: 'bold' }}>Your Position</p>
          <Select
            options={options}
            onChange={(e) => changeSchoolEmployee(e)}
            value={schoolEmployee}
            label="Single select"
            placeholder={"Select your position"}
            required
          />
        </>
      )}

      {schoolEmployee && school && (
        <>
          <br/>
          <div style={{ textAlign: 'center' }}>
            <a href={formatUrl()} className="btn btn-primary btn-lg">
              Continue
            </a>
          </div>
        </>
      )}
    </>
  )
}

SchoolAsyncSelect.propTypes = {
  name: PropTypes.string,
  selectedValue: PropTypes.object,
  valueField: PropTypes.string,
  extraFields: PropTypes.array,
  placeholder: PropTypes.string,
}

SchoolAsyncSelect.defaultProps = {
  name: null,
  selectedValue: null,
  valueField: 'name',
  extraFields: [],
  placeholder: 'Search',
}

export default SchoolAsyncSelect
